// import _ from "lodash";
import { Col, Grid, Row } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { compose, lifecycle, pure, withHandlers, withState } from "recompose";
import { getBudgeaUrl, getSettingsUrl } from "./BudgeaUrlHandler";
import { graphql, withApollo } from "react-apollo";

import AddBankButton from "../../../elements/ActionButtons/AddBankButton";
import BankAccountSelect from "../../BankAccount/BankAccountSelect";
import BudgeaAPI from "../../../tools/budgeaAPI";
import Card from "../../Card/Card";
import ConnectBankButton from "../../../elements/ActionButtons/ConnectBankButton";
// import ConnectBankSelectPure from "../ConnectBankSelect/ConnectBankSelect";
import FixedAlertTextInfo from "../../../elements/NotificationContent/FixedAlertTextInfo";
// import ListFilters from '../../../elements/List/ListFilters';
// import { NewButton} from '../../../elements/ActionButtons/NewButton.jsx';

import MainContentHeader from "../../Header/MainContentHeader.jsx";
// import SuperpositionHeader from "../../Header/SuperpositionHeader";

import PaymentLastUpdate from "./PaymentLastUpdate";
import PaymentList from "./PaymentList";
import PaymentTabs from "./PaymentTabs";
import PropTypes from "prop-types";
import Queries from "../../../queries/queries2";
import React from "react";
// import SimpleSelect from "../../../elements/CustomSelect/SimpleSelect";
import { withRouter } from "react-router-dom";

import SuperpositionHeader from "../../../components/Header/SuperpositionHeader";
import EmptyPaymentListJumbo from "./PaymentListEmptyJumbo";


const tabData = graphql(Queries.GET_BANK_TRANSACTIONS_COUNT,
  {
    name: "tabData",
    options: ({ bankAccountSelected }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: { bankAccountId: bankAccountSelected.id }
      };
    }
  }
);

const transactionAutoQualifCount = graphql(Queries.GET_BANK_ACCOUNT_AUTOQUALIF_TRANSACTION_COUNT,
  {
    name: "transactionAutoQualifCount",
    options: ({ bankAccountSelected }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: { bankAccountId: bankAccountSelected.id }
      };
    }
  }
);

const transactionMissingExpenseInvoiceCount = graphql(Queries.GET_BANK_ACCOUNT_WITHOUT_EXPENSEINVOICE_TRANSACTION_COUNT,
  {
    name: "transactionMissingExpenseInvoiceCount",
    options: ({ bankAccountSelected }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: { bankAccountId: bankAccountSelected.id }
      };
    }
  }
);

const syncronizeProviderAccounts = graphql(Queries.syncronizeProviderAccounts, {
  name: "syncronizeProviderAccounts"
});

// const unsyncProviderAccount = graphql(Queries.unsyncProviderAccount, {
//   name: "unsyncProviderAccount"
// });
const createProviderAccount = graphql(Queries.createProviderAccount, {
  name: "createProviderAccount"
});

const createAccessToken = graphql(Queries.createAccessToken, {
  name: "createAccessToken"
});

const resetAccessToken = graphql(Queries.resetAccessToken, {
  name: "resetAccessToken"
});



// const updateProviderAccount = graphql(Queries.updateProviderAccount, {
//   name: "updateProviderAccount"
// });

// const createBankAccountFromProviderAccount = graphql(
//   Queries.createBankAccountFromProviderAccount,
//   {
//     name: "createBankAccountFromProviderAccount"
//   }
// );

const searchTerm = withState("searchTerm", "setSearchTerm", () => {
  const searchTerm =
    sessionStorage.getItem("paymentListState_searchTerm") || "";
  return searchTerm;
});

const budgeaClient = withState(
  "budgeaClient",
  "setBudgeaClient",
  ({ BiAccessToken, BiUserId }) => {
    // console.log("94 - budgeaClient", BiAccessToken, BiUserId);
    let client = new BudgeaAPI(process.env.REACT_APP_BUDGEA_ENDPOINT, {
      redirect_uri: process.env.REACT_APP_BUDGEA_REDIRECTION_URL,
      client_id: process.env.REACT_APP_BUDGEA_CLIENT_ID,
      client_secret: process.env.REACT_APP_BUDGEA_CLIENT_SECRET
    });
    if (BiAccessToken && BiUserId) {
      client.setAccessToken(BiAccessToken);
      client.setClientId(BiUserId);
    }

    return client;
  }
);

const dateRange = withState("dateRange", "setDateRange", () => {
  const dateRange = JSON.parse(
    sessionStorage.getItem("paymentListState_dateRange")
  ) || {
    from: undefined,
    to: undefined
  };
  return dateRange;
});

const tabSelected = withState("tabSelected", "setTabSelected", () => {
  const tabSelected = JSON.parse(
    sessionStorage.getItem("paymentListState_tabSelected")
  ) || {
    // name: "toQualify",
    name: "all",
    count: 0
  };
  return tabSelected;
});

const refreshInProgress = withState("refreshInProgress", "setRefreshInProgress", () => {  
  return false;
});

// const tabAutoSelected = withState("tabAutoSelected", "setTabAutoSelected", () => {
//   const tabAutoSelected = null;
//   return tabAutoSelected;
// });


const bankAccountSelected = withState(
  "bankAccountSelected",
  "setBankAccountSelected",
  ({ bankAccounts }) => {

    const defaultBankAccount = bankAccounts[0] || {
      id: "",
      currency: { id: "" }
    };

    const preselectedBankAccountId = sessionStorage.getItem(
      "paymentListState_bankAccountSelected_default_ID"
    );
    console.log("176 - bankAccounts=", preselectedBankAccountId, bankAccounts);

    let savedBankAccount = defaultBankAccount;
    if (preselectedBankAccountId !== undefined || preselectedBankAccountId !== null) {
      for (const bankAccount of bankAccounts) {

        if (bankAccount.id === preselectedBankAccountId) {
          savedBankAccount = bankAccount;
        }
      }
      sessionStorage.removeItem(
        "paymentListState_bankAccountSelected_default_ID"
      );
    }
    else {
      savedBankAccount = JSON.parse(
        sessionStorage.getItem("paymentListState_bankAccountSelected")
      );
    }

    let bankAccountSelected;
    if (savedBankAccount && savedBankAccount.id) {
      bankAccountSelected = savedBankAccount;
    } else {

      bankAccountSelected = defaultBankAccount;
      sessionStorage.setItem(
        "paymentListState_bankAccountSelected",
        JSON.stringify(bankAccountSelected)
      );
    }
    sessionStorage.setItem(
      `paymentListState_tabAutoSelected`,
      JSON.stringify(null)
    );
    return bankAccountSelected;
  }
);

const visibleFilters = withState("visibleFilters", "setVisibleFilters", () => {
  return true;
});

const disabled = withState("disabled", "setDisabled", () => {
  return false;
});

const loading = withState("loading", "setLoading", () => {
  return false;
});

const handlers = withHandlers({
  clickEdit: ({ location, budgeaClient }) => async () => {
    console.log("clickEdit");
    const budgeaUrl = await getSettingsUrl(budgeaClient, location);
    // const budgeaUrl =
    // "https://netwips.biapi.pro/2.0/auth/webview/connect/select?client_id=77153445&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fbudgea&state=netwips#dposGunkVM5FjQXG6Lo55qYZSRFFFjS_";
    console.log("clickEdit getSettingsUrl", budgeaUrl);
    window.location.href = budgeaUrl;
  },
  clickNew: ({ location, budgeaClient, companyId, resetAccessToken }) => async () => {
    const variables = {
      companyId: companyId,
    };

    await resetAccessToken({
      variables
    });

    //
    // SINCE IT'S NEW =>  RESET budgeaClient.Client ID
    //
    let newBudgeaClient = new BudgeaAPI(process.env.REACT_APP_BUDGEA_ENDPOINT, {
      redirect_uri: process.env.REACT_APP_BUDGEA_REDIRECTION_URL,
      client_id: process.env.REACT_APP_BUDGEA_CLIENT_ID,
      client_secret: process.env.REACT_APP_BUDGEA_CLIENT_SECRET
    });

    const budgeaUrl = await getBudgeaUrl(newBudgeaClient, location);
    console.log("clickNew getBudgeaUrl", budgeaUrl);
    window.location.href = budgeaUrl;
  },
  onRefreshAccount: ({ companyId, refreshBankAccount, setDisabled }) => async (bankAccount) => {
    setDisabled(true);

    console.log("180 - onRefreshAccount=", bankAccount);
    console.log("181 - companyId=", companyId);
    console.log("182 - refreshBankAccount=", refreshBankAccount);

    const id = bankAccount.bankAccount.id;
    try {
      await refreshBankAccount({
        variables: { bankAccountId: bankAccount.bankAccount.id },
        refetchQueries: [
          { query: Queries.GET_ALL_BANK_ACCOUNTS, variables: { companyId } },
          { query: Queries.GET_BANK_ACCOUNT, variables: { id } }
        ]
      });
    } catch (e) {
      console.log(e);
    }

    setTimeout(() => {
      setDisabled(false);
    }, 10000);
  },
  handleFilterChange: ({
    setBankAccountSelected,
    setTabSelected,
    setSearchTerm,
    // setTabAutoSelected,
    setDateRange,    
    setRefreshInProgress
  }) => (key, value) => {
    switch (key) {
      case "bankAccountSelected":
        setBankAccountSelected(value);
        sessionStorage.setItem(
          `paymentListState_bankAccountSelected`,
          JSON.stringify(value)
        );
        // setTabAutoSelected(null);

        sessionStorage.setItem(
          `paymentListState_tabAutoSelected`,
          JSON.stringify(null)
        );
        console.log("setTabAutoSelected NULL");        
        setRefreshInProgress(true);
        break;
      case "tabSelected":
        setTabSelected(value);
        sessionStorage.setItem(
          `paymentListState_tabSelected`,
          JSON.stringify(value)
        );        
        setRefreshInProgress(true);
        break;
      case "searchTerm":
        setSearchTerm(value);
        sessionStorage.setItem(`paymentListState_searchTerm`, value);
        break;
      case "dateRange":
        console.log("dateRange", value);
        setDateRange(value);
        sessionStorage.setItem(
          `paymentListState_dateRange`,
          JSON.stringify(value)
        );
        break;
      default:
        sessionStorage.setItem(`paymentListState_${key}`, value);
    }
  }
});



const componentLifecycle = lifecycle({

  async componentDidMount() {
    // console.log("212 - PaymentListContainer componentDidMount", this.props);

    // const tabSelected = JSON.parse( sessionStorage.getItem("paymentListState_tabSelected"));
    // console.log("tabSelected=", tabSelected);

    // const toSetTabToDo = (
    //   ( this.props.tabData && this.props.tabData.toQualifyCount && this.props.tabData.toQualifyCount.count > 0) ||
    //   ( this.props.transactionAutoQualifCount && this.props.transactionAutoQualifCount._bankTransactionsMeta && this.props.transactionAutoQualifCount._bankTransactionsMeta.count > 0 ) 
    // );

    // if ( !tabSelected && toSetTabToDo === true){
    //   this.setTabSelected("toDo");
    //   console.log("=> set tab!");
    // }

    // if (
    //   (tabData && tabData.toQualifyCount && tabData.toQualifyCount.count > 0 ) ||
    //   (transactionAutoQualifCount && transactionAutoQualifCount._bankTransactionsMeta && transactionAutoQualifCount._bankTransactionsMeta.count > 0 )
    // ){
    //   console.log("563 - SET TAB SELECTED...");

    // }


    // this.props.history.push({
    //   pathname: "/budgea"
    //   // search: "?the=search",
    //   // state: { budgeaClient }
    // });
    return;

    // const hasTokenInDb = this.props.budgeaClient.getAccessToken();
    // console.log("hasTokenInDb", hasTokenInDb);

    // try {
    //   console.log("1 parse location");
    //   await parseLocation(this.props.budgeaClient, this.props.location);
    // } catch (e) {
    //   console.log("componentDidMount error", e);
    //   this.props.sendFailureNotification(e);
    // }

    // console.log("2 get token");
    // const access_token = this.props.budgeaClient.getAccessToken();
    // console.log("client.access_token", access_token);
    // if (access_token) {
    //   console.log("3 get accounts");
    //   const accounts = await this.props.budgeaClient.getAccounts();
    //   console.log("accounts", accounts);

    //   if (!hasTokenInDb && accounts && accounts.length > 0) {
    //     // store token
    //     const variables = {
    //       companyId: this.props.companyId,
    //       userId: accounts && Number(accounts[0].id_user),
    //       accessToken: access_token,
    //       active: true
    //     };
    //     console.log("store access token", variables);
    //     await this.props.createAccessToken({
    //       variables
    //     });
    //   }

    //   // disable
    //   console.log("providerAccounts", this.props.providerAccounts);
    //   // delete missing accounts
    //   // let matchingAccounts = [];
    //   let addedAccounts = [];
    //   // let removedAccounts = [];

    //   // lookup matching accounts
    //   // _.forEach(this.props.providerAccounts, a => {
    //   //   const t = _.find(accounts, b => {
    //   //     return b.id.toString() === a.accountId;
    //   //   });
    //   //   if (t) matchingAccounts.push(a);
    //   // });

    //   _.forEach(accounts, a => {
    //     const t = _.find(this.props.providerAccounts, b => {
    //       return a.id.toString() === b.accountId;
    //     });
    //     if (t === undefined) addedAccounts.push(a);
    //   });

    //   // lookup unsynced accounts
    //   // _.forEach(this.props.providerAccounts, a => {
    //   //   const t = _.find(accounts, b => {
    //   //     console.log("a:", a.accountId, "b:", b.id);
    //   //     return a.accountId === b.id.toString();
    //   //   });
    //   //   if (t === undefined) removedAccounts.push(a);
    //   // });

    //   // console.log("matchingAccounts", matchingAccounts);
    //   console.log("addedAccounts", addedAccounts);
    //   // console.log("removedAccounts", removedAccounts);
    //   // console.log("bankAccounts", this.props.bankAccounts);

    //   // lookup matching acount to update syncAccount
    //   // _.forEach(matchingAccounts, async o => {
    //   //   // set sync to false
    //   //   await this.props.updateProviderAccount({
    //   //     variables: {
    //   //       where: { id: o.id },

    //   //       companyId: this.props.companyId,
    //   //       data: {
    //   //         syncAccount: true
    //   //       }
    //   //     }
    //   //   });
    //   // });

    //   // handle synsynced accounts
    //   // _.forEach(removedAccounts, async o => {
    //   //   // set sync to false
    //   //   await this.props.updateProviderAccount({
    //   //     variables: {
    //   //       where: { id: o.id },

    //   //       companyId: this.props.companyId,
    //   //       data: {
    //   //         syncAccount: false
    //   //       }
    //   //     }
    //   //   });
    //   // });

    //   // store provider accounts and related access token
    //   // handle added accounts, by creating missing provider accounts
    //   // _.forEach(addedAccounts, async o => {
    //   //   if (0 === 0) return;

    //   //   const currency = await this.props.client.query({
    //   //     query: Queries.GetCurrencyByCode,
    //   //     variables: {
    //   //       code: o.currency.id
    //   //     }
    //   //   });
    //   //   // console.log("CURRENCY", currency.data.currency.id);

    //   //   const newAccount = {
    //   //     company: {
    //   //       connect: { id: this.props.companyId }
    //   //     },
    //   //     accountId: o.id.toString(),
    //   //     name: o.name,
    //   //     originalName: o.original_name,
    //   //     iban: o.iban,
    //   //     bic: o.bic,
    //   //     number: o.number,
    //   //     solde: o.balance,
    //   //     dateLastUpdate: moment(o.last_update).toISOString(),
    //   //     typeBankAccount: o.type,
    //   //     provider: "BUDGETINSIGHT",
    //   //     currency: {
    //   //       connect: {
    //   //         id: currency.data.currency.id
    //   //       }
    //   //     },
    //   //     syncAccount: true
    //   //     // biConnexion: {
    //   //     //   create: {
    //   //     //     userId: o.id_user,
    //   //     //     accessToken: access_token,
    //   //     //     connexionId: o.id_connection,
    //   //     //     active: true,
    //   //     //     company: { connect: { id: this.props.companyId } }
    //   //     //   }
    //   //     // }
    //   //   };

    //   //   // console.log("adding account", newAccount);
    //   //   // push new account
    //   //   try {
    //   //     const res = await this.props.createProviderAccount({
    //   //       variables: {
    //   //         companyId: this.props.companyId,
    //   //         data: newAccount
    //   //       }
    //   //       // refetchQueries: [
    //   //       //   {
    //   //       //     query: Queries.GET_ALL_BANK_ACCOUNTS,
    //   //       //     variables: { companyId: this.props.companyId }
    //   //       //   }
    //   //       // ]
    //   //     });
    //   //     console.log("added account", JSON.stringify(res, null, 2));
    //   //   } catch (e) {
    //   //     console.log("adding account error", e);
    //   //   }
    //   // });

    //   // delete providerAccount
    //   // _.forEach(addedAccounts, async o => {
    //   // });

    //   // this.props.sendSuccessUpdateNotification();
    //   // lookup missing bank accounts
    //   // let missingBankAccounts = [];
    //   // _.forEach(this.props.providerAccounts, o => {
    //   //   const t = _.find(this.props.bankAccounts, i => {
    //   //     const matchingProviderAccount = i.providerAccount;
    //   //     return (
    //   //       matchingProviderAccount &&
    //   //       matchingProviderAccount.accountId === o.accountId
    //   //     );
    //   //   });
    //   //   if (t === undefined) missingBankAccounts.push(o);
    //   // });

    //   // handle missing bank accounts by creating bank accounts
    //   //   console.log("missingBankAccounts", missingBankAccounts);
    //   //   _.forEach(missingBankAccounts, async o => {
    //   //     //create bankBankAccounts.
    //   //     console.log("createBankAccount", o);
    //   //     // return;
    //   //     const res = await this.props.createBankAccountFromProviderAccount({
    //   //       variables: {
    //   //         companyId: this.props.companyId,
    //   //         providerId: o.id
    //   //       },
    //   //       refetchQueries: [
    //   //         {
    //   //           query: Queries.GET_ALL_BANK_ACCOUNTS,
    //   //           variables: { companyId: this.props.companyId }
    //   //         }
    //   //       ]
    //   //     });
    //   //     console.log("createBankAccount res", res);
    //   //   });

    //   if (addedAccounts.length > 0) {
    //     console.log("syncronizeProviderAccounts");
    //     const res = await this.props.syncronizeProviderAccounts({
    //       variables: {
    //         companyId: this.props.companyId
    //       }
    //       // refetchQueries: [
    //       //   {
    //       //     query: Queries.GET_ALL_BANK_ACCOUNTS,
    //       //     variables: { companyId: this.props.companyId }
    //       //   }
    //       // ]
    //     });

    //     console.log("syncronizeProviderAccounts res", res);
    //     this.props.history.push("/payments");
    //   }
    // }

    // this.props.history.push("/payments");
  },

  async componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log(
    //   "473 - PaymentListContainer componentDidUpdate",
    //   prevProps,
    //   prevState,
    //   snapshot
    // );

    const toSetTabToDo = (
      (
        this.props.tabData && this.props.tabData.toQualifyCount &&
        this.props.tabData.toQualifyCount.count > 0
      ) ||
      (
        this.props.transactionAutoQualifCount &&
        this.props.transactionAutoQualifCount._bankTransactionsMeta &&
        this.props.transactionAutoQualifCount._bankTransactionsMeta.count > 0
      )
    );

    const toSetTabToJustify = (
      (
        this.props.tabData && this.props.tabData.toQualifyCount &&
        this.props.tabData.toQualifyCount.count === 0
      ) &&
      (
        this.props.transactionAutoQualifCount &&
        this.props.transactionAutoQualifCount._bankTransactionsMeta &&
        this.props.transactionAutoQualifCount._bankTransactionsMeta.count === 0
      ) &&
      (
        this.props.transactionMissingExpenseInvoiceCount &&
        this.props.transactionMissingExpenseInvoiceCount._bankTransactionsMeta &&
        this.props.transactionMissingExpenseInvoiceCount._bankTransactionsMeta.count > 0
      )
    );

    // console.log("587 - toSetTabToDo", toSetTabToDo);
    // console.log("588 - toSetTabToJustify", toSetTabToJustify);

    const tabAutoSelected = JSON.parse(sessionStorage.getItem("paymentListState_tabAutoSelected"));
    // console.log("502 - tabAutoSelected", tabAutoSelected);

    if (this.props.tabSelected.name !== "toDo" && toSetTabToDo === true) {

      const tab = {
        name: "toDo",
        count: 1
      };

      if (tabAutoSelected === null) {
        console.log("============> set tab todo!", tab);
        // this.props.setTabAutoSelected(tab);

        sessionStorage.setItem(
          `paymentListState_tabAutoSelected`,
          JSON.stringify(tab)
        );

        this.props.setTabSelected(tab);
      }
    }
    else if (this.props.tabSelected.name !== "toJustify" && toSetTabToJustify === true) {
      const tab = {
        name: "toJustify",
        count: 1
      };

      if (tabAutoSelected === null) {
        console.log("============> set tab toJustify!", tab);
        // this.props.setTabAutoSelected(tab);

        sessionStorage.setItem(
          `paymentListState_tabAutoSelected`,
          JSON.stringify(tab)
        );

        this.props.setTabSelected(tab);
      }
    }
    else if (this.props.tabSelected.name !== "all" && toSetTabToDo === false && toSetTabToJustify === false) {

      const tab = {
        name: "all",
        count: 1
      };

      if (tabAutoSelected === null) {
        console.log("============> set tab all !", tab);
        // this.props.setTabAutoSelected(tab);

        sessionStorage.setItem(
          `paymentListState_tabAutoSelected`,
          JSON.stringify(tab)
        );

        this.props.setTabSelected(tab);
      }
    }
  }

});

let clickHere = pl => {
  return <FormattedMessage id="ids_clickHere" />;
};

let NoAccountDisplayLine = placeholder => {
  return (
    <span>
      {placeholder},
      <strong onClick={() => console.log("NoAccountDisplayLine click")}>
        {clickHere}
      </strong>
    </span>
  );
};

let NoAccountDisplay = () => {
  return (
    <FormattedMessage
      id="ids_connectBankAccountAlert"
      description="no account alert"
      defaultMessage="Pour connecter vos comptes bancaires à Netwips et auttiomatiser votre comptabilité,">
      {placeholder => (
        <FixedAlertTextInfo text={NoAccountDisplayLine(placeholder)} />
      )}
    </FormattedMessage>
  );
};

// const BANK_TRANSACTION_QUALIFIED_SUBSCRIPTION = gql`
//   subscription onBankTransactionQualified($companyId: ID!) {
//     bankTransactionQualified(companyId: $companyId) {
//       id
//     }
//   }
// `;

// const DontReadTheComments = companyId => (
//   <Subscription
//     subscription={BANK_TRANSACTION_QUALIFIED_SUBSCRIPTION}
//     variables={{ companyId }}>
//     {({ data, loading }) => {
//       const bankTransactionQualified = data && data.bankTransactionQualified;
//       console.log("SUB-", bankTransactionQualified, loading);
//       return (
//         <h4>
//           New comment:{" "}
//           {!loading && bankTransactionQualified && bankTransactionQualified.id}
//         </h4>

//         // <h4>New comment: {!loading && data && data.bankTransactionQualified && data.bankTransactionQualified.id}</h4>
//       );
//     }}
//   </Subscription>
// );

let PaymentListContainerPure = ({
  tiersId, // when filtering from contacts
  hidden = false,
  currency,
  companyId,
  BiAccessToken,
  BiUserId,

  handleFilterChange,
  clickNew,
  clickEdit,
  onRefreshAccount,
  bankAccountSelected,
  searchTerm,
  dateRange,
  tabSelected,
  tabAutoSelected,
  bankAccounts,
  visibleFilters,
  updateBankTransaction,
  confirmBankTransaction,
  validateAllBankTransactions,
  setVisibleFilters,
  path,
  name,
  location,
  // budgeaClient,
  sendFailureNotification,
  sendSuccessUpdateNotification,
  locale,
  intl,
  history,
  tabData,
  transactionAutoQualifCount,
  transactionMissingExpenseInvoiceCount,
  setTabSelected,
  handleMinimizeSidebar,
  disabled,
  companyDefaultInfos,
  exchangeRateForTiers,
  loading,
  setLoading,
  refreshInProgress,
  setRefreshInProgress
  // setTabAutoSelected
}) => {
  // console.log("PaymentListContainerPure", tiersId, BiAccessToken); //, bankAccounts);

  let bankAccountCounts = (bankAccounts && bankAccounts.length) || 0;
  // bankAccountCounts = 1;

  // console.log("currencyID", currencyId);
  let options = [];
  options.push({
    label: "ids_connectMyBank",
    value: 0
  });
  // console.log("bankAccountSelected", bankAccountSelected, tabSelected);

  // console.log("558 - tabData=", tabData && tabData.toQualifyCount && tabData.toQualifyCount.count);
  // console.log("559 - transactionAutoQualifCount=", transactionAutoQualifCount && transactionAutoQualifCount._bankTransactionsMeta && transactionAutoQualifCount._bankTransactionsMeta.count);


  // const savedTabSelected = JSON.parse( sessionStorage.getItem("paymentListState_tabSelected"));
  // console.log("tabSelected=", tabSelected, savedTabSelected);

  // const toSetTabToDo = (
  //   ( tabData && tabData.toQualifyCount && tabData.toQualifyCount.count > 0) ||
  //   ( transactionAutoQualifCount && transactionAutoQualifCount._bankTransactionsMeta && transactionAutoQualifCount._bankTransactionsMeta.count > 0 ) 
  // );

  // if ( /*!savedTabSelected && tabSelected.name !== "toDo" &&*/ toSetTabToDo === true){

  //   const tab = {
  //     name: "toDo",
  //     count: 1
  //   };
  //   console.log("=> set tab!", tab);
  //   setTabSelected(tab);    
  // }

  // console.log("635 - tab selected=", tabSelected, tabAutoSelected, bankAccounts, bankAccountCounts, BiAccessToken);

  let error = false;
  let nbErrors = 0;
  for (let i = 0; i < bankAccountCounts; i++) {
    if (bankAccounts[i].providerAccount && bankAccounts[i].providerAccount.error) {
      // console.log("711 - X=", bankAccounts[i].providerAccount.error);
      error = true;
      nbErrors++;
    }
  }

  return (
    <div>

      <FormattedMessage id={name}>
        {backBtnText => (
          <SuperpositionHeader
            backBtnText={backBtnText}
            transparent={true}
            handleMinimizeSidebar={handleMinimizeSidebar}
          >
            <div>
              {/* <ConnectBankButton
                className="btn-fill pull-right margin-left-20"
                onClick={
                  BiAccessToken === undefined || BiAccessToken === ""
                    ? () => clickNew()
                    : () => clickEdit()
                }
                ids={
                  BiAccessToken === undefined || BiAccessToken === ""
                    ? "ids_connectMyBank"
                    : "ids_connectMyBank"
                }
              />

              <AddBankButton className=" pull-right margin-left-20"
                onClick={() => history.push("/payments/bank_accounts/new")}
              /> */}
            </div>
          </SuperpositionHeader>
        )}
      </FormattedMessage>

      <Grid fluid hidden={hidden}>
        {/* <MainContentHeader
          name={name}
          hasBtn={true}
        >
          <ConnectBankButton
            className="btn-fill pull-right margin-left-20"
            onClick={
              BiAccessToken === undefined || BiAccessToken === ""
                ? () => clickNew()
                : () => clickEdit()
            }
            ids={
              BiAccessToken === undefined || BiAccessToken === ""
                ? "ids_connectMyBank"
                : "ids_connectMyBank"
            }
          />

          <AddBankButton className="btn-fill pull-right margin-left-20"
            onClick={() => history.push("/payments/bank_accounts/new")}
          />

        </MainContentHeader> */}

        {/*  <Navbar fluid>
          <Navbar.Header>
            <Navbar.Brand>
              <a href="#home">React-Bootstrap</a>
            </Navbar.Brand>
          </Navbar.Header>
          <Nav>
            <NavItem eventKey={1} href="#">
              Link
            </NavItem>
            <NavItem eventKey={2} href="#">
              Link
            </NavItem>
            <NavDropdown eventKey={3} title="Dropdown" id="basic-nav-dropdown">
              <MenuItem eventKey={3.1}>Action</MenuItem>
              <MenuItem eventKey={3.2}>Another action</MenuItem>
              <MenuItem eventKey={3.3}>Something else here</MenuItem>
              <MenuItem divider />
              <MenuItem eventKey={3.4}>Separated link</MenuItem>
            </NavDropdown>
          </Nav>
        </Navbar> */}

        {/* <NewButton wd className="btn-fill pull-right"
          newRecordUrl={`${path}/new`}/>  */}

        <div className="main-content" style={
          // loading ?
          // { pointerEvents: "none", opacity: "0.4", marginTop: "32px"} :
          { marginTop: "32px" }
        }>
          <Row>
            {/* {bankAccountCounts === 0 && <NoAccountDisplay />} */}
            {/* {bankAccountCounts > 0 && ( */}
            <div>
              {/* <Col md={4} sm={6} mdOffset={4} smOffset={3}></Col> */}
              <Col xs={12} sm={7} lg={7} mdOffset={2}>
                <div className="space-between">
                  <BankAccountSelect
                    companyId={companyId}
                    bankAccounts={bankAccounts}
                    displayClosed={true}
                    onSelected={element =>
                      element &&
                      handleFilterChange(
                        "bankAccountSelected",
                        element.account
                      )
                    }
                    value={bankAccountSelected.id}
                    intl={intl}
                  />
                  {/* <div className="margin-left-20" />                    */}
                </div>
              </Col>
              <Col xs={12} sm={3} lg={3} style={{ marginTop: "8px" }}>
                <PaymentLastUpdate
                  id={bankAccountSelected.id}
                  companyId={companyId}
                  locale={locale}
                  onRefreshAccount={(data) => onRefreshAccount(data)}
                  disabled={disabled}
                // disabled={loading}
                />
              </Col>
            </div>
            {/* )} */}
          </Row>

          <Row>
            <Col xs={12} sm={3} lg={3} mdOffset={2}>
              <div
                style={{ textAlign: "Center" }}
                onClick={() =>
                  (BiAccessToken === undefined || BiAccessToken === "" || bankAccountCounts === 0)
                    ? clickNew()
                    : clickEdit()
                }
              >
                {/* { error ? 
                 <div className="fa fa-warning " style={{ color: "red" }} />
                 : <div></div>
                } */}
                <a style={error ? { color: "Red" } : {}}>
                  {intl.formatMessage({
                    id: (BiAccessToken === undefined || BiAccessToken === "" || bankAccountCounts === 0)
                      ? "ids_connectMyBank"
                      : "ids_modifyConnectedBank"
                  }) + (nbErrors > 0 ? ' (' + nbErrors + ')' : "")}
                </a>
              </div>
            </Col>

            <Col xs={12} sm={3} lg={3}>
              <div
                style={{ textAlign: "Center" }}
                onClick={() => history.push("/payments/bank_accounts/new")}>
                <a >
                  {intl.formatMessage({ id: "ids_addBank" })}
                </a>
              </div>
            </Col>
          </Row>

          {/* {bankAccountCounts > 0 && ( */}
          <div className="margin-top-40">
            <PaymentTabs
              bankAccountId={bankAccountSelected.id}
              handleTabSelect={element =>
                handleFilterChange("tabSelected", element)
              }
              tabSelected={tabSelected}
              companyId={companyId}
              tiersId={tiersId}
            />
            <Card>
              {bankAccountCounts > 0 && (
                <PaymentList
                  companyDefaultInfos={companyDefaultInfos}
                  tabSelected={tabSelected}
                  searchTerm={searchTerm}
                  dateRange={dateRange}
                  updateBankTransaction={updateBankTransaction}
                  confirmBankTransaction={confirmBankTransaction}
                  validateAllBankTransactions={validateAllBankTransactions}
                  onRowSelect={inSelection => setVisibleFilters(!inSelection)}
                  bankAccountId={bankAccountSelected.id}
                  currency={bankAccountSelected.currency}
                  tiersId={tiersId}
                  companyId={companyId}
                  locale={locale}
                  exchangeRateForTiers={exchangeRateForTiers}
                  setLoading={setLoading}
                  refreshInProgress={refreshInProgress}
                  setRefreshInProgress={setRefreshInProgress}
                />
              )}

              {bankAccountCounts === 0 && (
                <div className="margin-top-40">
                  <EmptyPaymentListJumbo
                    BiAccessToken={BiAccessToken}
                    bankAccountCounts={bankAccountCounts}
                    clickNew={clickNew}
                    clickEdit={clickEdit}
                    history={history}
                  />
                </div>
              )}

            </Card>
          </div>
          {/* )} */}
        </div>
      </Grid>
    </div>
  );
};

PaymentListContainerPure.propTypes = {
  currency: PropTypes.string,
  companyId: PropTypes.string,
  bankAccounts: PropTypes.array,
  searchTerm: PropTypes.string,
  tabSelected: PropTypes.object,
  tabAutoSelected: PropTypes.object,
  //{
  //   name: PropTypes.string,
  //   count: PropTypes.int
  // },
  bankAccountSelected: PropTypes.object
  // {
  //   id: PropTypes.string,
  //   currency: {
  //     id: PropTypes.string
  //   }
  // }
};

const PaymentListContainer = compose(
  withRouter,
  graphql(Queries.refreshBankAccount, {
    name: "refreshBankAccount"
  }),
  graphql(Queries.getExchangeRate, {
    name: "exchangeRateForTiers"
  }),
  withApollo,
  // getCurrencyByCode,
  createProviderAccount,
  createAccessToken,
  resetAccessToken,
  // updateProviderAccount,
  // unsyncProviderAccount,
  // createBankAccountFromProviderAccount,
  syncronizeProviderAccounts,
  budgeaClient,
  searchTerm,
  dateRange,
  tabSelected,
  bankAccountSelected,
  refreshInProgress,
  // tabAutoSelected,
  tabData,
  transactionAutoQualifCount,
  transactionMissingExpenseInvoiceCount,
  visibleFilters,
  disabled,
  loading,
  handlers,
  pure,
  componentLifecycle,
  injectIntl
)(PaymentListContainerPure);

export default PaymentListContainer;
